import React from 'react'
import ContestForm from './contestForm'

const EditContest = () => {
  return (
    <div>
      <ContestForm action="Edit"/>
    </div>
  )
}

export default EditContest
